/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_After_MinInputs */

const en_admin_resource_form_after_min = /** @type {(inputs: Admin_Resource_Form_After_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`After Min.`)
};

const de_admin_resource_form_after_min = /** @type {(inputs: Admin_Resource_Form_After_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ab min.`)
};

const es_admin_resource_form_after_min = /** @type {(inputs: Admin_Resource_Form_After_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Después de mín.`)
};

const fr_admin_resource_form_after_min = /** @type {(inputs: Admin_Resource_Form_After_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Après min.`)
};

const nl_admin_resource_form_after_min = /** @type {(inputs: Admin_Resource_Form_After_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na min.`)
};

/** @type {(inputs: Admin_Resource_Form_After_MinInputs) => LocalizedString} */
const it_admin_resource_form_after_min = en_admin_resource_form_after_min;

/** @type {(inputs: Admin_Resource_Form_After_MinInputs) => LocalizedString} */
const pt_br2_admin_resource_form_after_min = en_admin_resource_form_after_min;

/** @type {(inputs: Admin_Resource_Form_After_MinInputs) => LocalizedString} */
const pl_admin_resource_form_after_min = en_admin_resource_form_after_min;

/** @type {(inputs: Admin_Resource_Form_After_MinInputs) => LocalizedString} */
const hu_admin_resource_form_after_min = en_admin_resource_form_after_min;

/** @type {(inputs: Admin_Resource_Form_After_MinInputs) => LocalizedString} */
const ro_admin_resource_form_after_min = en_admin_resource_form_after_min;

/**
* | output |
* | --- |
* | "After Min." |
*
* @param {Admin_Resource_Form_After_MinInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_after_min = /** @type {((inputs?: Admin_Resource_Form_After_MinInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_After_MinInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_after_min(inputs)
	if (locale === "de") return de_admin_resource_form_after_min(inputs)
	if (locale === "es") return es_admin_resource_form_after_min(inputs)
	if (locale === "fr") return fr_admin_resource_form_after_min(inputs)
	if (locale === "nl") return nl_admin_resource_form_after_min(inputs)
	if (locale === "it") return it_admin_resource_form_after_min(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_after_min(inputs)
	if (locale === "pl") return pl_admin_resource_form_after_min(inputs)
	if (locale === "hu") return hu_admin_resource_form_after_min(inputs)
	return ro_admin_resource_form_after_min(inputs)
});
export { admin_resource_form_after_min as "admin.resource_form.after_min" }